import { createSelector } from "reselect";
import { path, prop, identity } from "ramda";

import { isUIComponentVisible } from "~/utils";

// Selectors
const getMenu = path(["domain", "ui", "menu"]);

export const selectMenu = createSelector(getMenu, identity);

export const selectIsMenuVisible = createSelector(getMenu, isUIComponentVisible);

export const selectShowEditModeButton = createSelector(getMenu, prop("showEditModeButton"));

export const selectShowCursorDefaultButton = createSelector(getMenu, prop("showCursorDefaultButton"));

export const selectShowAnnotationsShowHideButton = createSelector(getMenu, prop("showAnnotationsShowHideButton"));

export const selectShowDeleteButton = createSelector(getMenu, prop("showDeleteButton"));

export const selectShowDeleteAllAnnotationsButton = createSelector(getMenu, prop("showDeleteAllAnnotations"));

export const selectShowZoomOutButton = createSelector(getMenu, prop("showZoomOutButton"));

export const selectShowZoomInButton = createSelector(getMenu, prop("showZoomInButton"));

export const selectShowZoomResetButton = createSelector(getMenu, prop("showZoomResetButton"));

export const selectShowFullScreenButton = createSelector(getMenu, prop("showFullScreenButton"));

export const selectShowColorPickerButton = createSelector(getMenu, prop("showColorPickerButton"));

export const selectShowPageModeButton = createSelector(getMenu, prop("showPageModeButton"));

export const selectShowPrintButton = createSelector(getMenu, prop("showPrintButton"));

export const selectShowCutoutButton = createSelector(getMenu, prop("showCutoutButton"));

export const selectShowDeleteAllButton = createSelector(getMenu, prop("showDeleteAllButton"));

// Initial State
const initialState = () => ({
  showEditModeButton: true,
  showCursorDefaultButton: true,
  showAnnotationsShowHideButton: true,
  showDeleteButton: true,
  showZoomOutButton: true,
  showZoomInButton: true,
  showZoomResetButton: true,
  showFullScreenButton: true,
  showColorPickerButton: true,
  showPageModeButton: true,
  showPrintButton: true,
  showCutoutButton: true,
  showDeleteAllButton: true
});

// Reducer
export default function reducer(state = initialState(), action = {}) {
  switch (action.type) {
    default:
      return state;
  }
}
